import axiosInstance from '@/utils/api.js'

var state = {
  trafficCollectors: [],
  trafficCollectorsStats: []
}

var getters = {
  TRAFFIC_COLLECTORS: (state) => {
    return state.trafficCollectors
  },
  TRAFFIC_COLLECTORS_STATS: (state) => {
    return state.trafficCollectorsStats
  }
}

var mutations = {
  SET_TRAFFIC_COLLECTORS: (state, payload) => {
    state.trafficCollectors = payload
  },
  SET_TRAFFIC_COLLECTORS_STATS: (state, payload) => {
    state.trafficCollectorsStats = payload
  }
}

var actions = {
  GET_TRAFFIC_COLLECTORS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/collectors')
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_COLLECTORS', result.data)
    }
  },
  GET_TRAFFIC_COLLECTORS_STATS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/collector_stats?collector_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_COLLECTORS_STATS', result.data)
    }
  },
  CREATE_TRAFFIC_COLLECTORS: (context, payload) => {
    return axiosInstance.post('/settings/collectors', payload)
  },
  UPDATE_TRAFFIC_COLLECTORS: (context, payload) => {
    return axiosInstance.put('/settings/collectors', payload)
  },
  DELETE_TRAFFIC_COLLECTORS: (context, payload) => {
    return axiosInstance.delete('/settings/collectors?collector_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/trafficCollectors.js